<template>
<div>
    <v-starterdetailsevm v-if="chainId == 9001"></v-starterdetailsevm>
    <v-starterdetailsevmtest v-if="chainId == 9000"></v-starterdetailsevmtest>
    <v-starterdetailszk v-if="chainId == 280"></v-starterdetailszk>
    <v-starterdetailszkmain v-if="chainId == 324"></v-starterdetailszkmain>
    <v-starterdetailsscroll v-if="chainId == 534353"></v-starterdetailsscroll>
    <v-starterdetailsscrollsepolia v-if="chainId == 534351"></v-starterdetailsscrollsepolia>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId')
        },
    }
</script> 